<template>
    <div class="cs-course-validation"> 
        <div>
          <el-tabs class="cs-fullHeight" v-model="activeTab" type="card" @tab-click="clickTab">
          <el-tab-pane name="conflictType1">
            <span slot='label'>速成课时与大学课时冲突<i v-if="tableData.ConflictsInSPCourseAndStudentCourse.length>0" class="el-icon-warning red-icon"></i></span>
            <el-table ref="tableConflictType1" :data="tableData.ConflictsInSPCourseAndStudentCourse" stripe style="width: 100%" :cell-class-name="cellStyle" :header-row-class-name="'el-table-header'">
            <el-table-column prop="Phone" label="学生" min-width="10%">
              <template slot-scope="scope">
                  <div>
                      <el-button :class="{'isClicked':checkConflictsInSPCourseAndStudentCourseIsClicked(scope.$index)}" type="text" size="medium"  v-text="formatPhone(scope.row.Phone)" @click="showStudent(scope.row.StudentId, 1, scope.$index)"></el-button>
                  </div>
              </template>
            </el-table-column>
            <el-table-column prop="CourseName" label="课程" min-width="20%">
               <template slot-scope="scope">
                    <div>
                       <span v-text="getCourseName(scope.row)"></span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="TeacherName" label="老师" min-width="10%">
              <template slot-scope="scope">
                <div>
                    <el-button :class="{'isClicked':checkTeacherClicked(scope.row.TeacherId)}" type="text" size="medium"  v-text="scope.row.TeacherName" @click="showTeacher(scope.row.TeacherId, scope.row.TeacherName)"></el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="DayOfWeekText" label="日期" min-width="10%"> 
            </el-table-column>
            <el-table-column prop="SpeedupStartTimeText" label="速成开始" min-width="10%"> 
            </el-table-column>
            <el-table-column prop="SpeedupEndTimeText" label="速成结束" min-width="10%"> 
            </el-table-column>
            <el-table-column prop="StartTimeText" label="大学开始" min-width="10%"> 
            </el-table-column>
            <el-table-column prop="EndTimeText" label="大学结束" min-width="10%"> 
            </el-table-column>
          </el-table>
          </el-tab-pane>
          <el-tab-pane name="conflictType2">
            <span slot='label'>速成课程之间冲突<i v-if="tableData.ConflictsInTwoSPCourses.length>0" class="el-icon-warning red-icon"></i></span>
            <el-table ref="tableConflictType2" :data="tableData.ConflictsInTwoSPCourses" stripe style="width: 100%" :cell-class-name="cellStyle" :header-row-class-name="'el-table-header'">
            <el-table-column prop="Phone" label="学生" min-width="10%">
              <template slot-scope="scope">
                  <div>
                      <el-button :class="{'isClicked':checkConflictsInTwoSPCoursesIsClicked(scope.$index)}" type="text" size="medium" v-text="formatPhone(scope.row.Phone)" @click="showStudent(scope.row.StudentId, 2, scope.$index)"></el-button>
                  </div>
              </template>
            </el-table-column>
            <el-table-column prop="ACourseName" label="课程A" min-width="15%">
               <template slot-scope="scope">
                    <div>
                       <span v-text="getACourseName(scope.row)"></span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="ATeacherName" label="课程A老师" min-width="10%">
               <template slot-scope="scope">
                <div>
                    <el-button :class="{'isClicked':checkTeacherClicked(scope.row.ATeacherId)}" type="text" size="medium"  v-text="scope.row.ATeacherName" @click="showTeacher(scope.row.ATeacherId, scope.row.ATeacherName)"></el-button>
                </div>
              </template>
            </el-table-column>
             <el-table-column prop="BCourseName" label="课程B" min-width="15%">
                <template slot-scope="scope">
                    <div>
                       <span v-text="getBCourseName(scope.row)"></span>
                    </div>
                </template>
            </el-table-column>
             <el-table-column prop="BTeacherName" label="课程B老师" min-width="10%">
                <template slot-scope="scope">
                <div>
                    <el-button :class="{'isClicked':checkTeacherClicked(scope.row.BTeacherId)}" type="text" size="medium"  v-text="scope.row.BTeacherName" @click="showTeacher(scope.row.BTeacherId, scope.row.BTeacherName)"></el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="DayOfWeekText" label="日期" min-width="5%"> 
            </el-table-column>
            <el-table-column prop="AStartTimeText" label="课程A开始" min-width="8%"> 
            </el-table-column>
            <el-table-column prop="AEndTimeText" label="课程A结束" min-width="8%"> 
            </el-table-column>
            <el-table-column prop="BStartTimeText" label="课程B开始" min-width="8%"> 
            </el-table-column>
            <el-table-column prop="BEndTimeText" label="课程B结束" min-width="8%"> 
            </el-table-column>
          </el-table>
          </el-tab-pane>
          </el-tabs>
         
        </div>
        <el-dialog append-to-body title="在校课程时间表" :center="true" :close-on-click-modal="false" width="70%" :visible.sync="displayStudentCourse" top="5vh">
          <studentCourseReview :data="currentStudentData" @close="closeStudentCourse" v-on:dialogFormVisibleEvent="onDialogFormVisibleEvent"></studentCourseReview>
        </el-dialog> 
        <el-dialog append-to-body title="老师课程时间表" :center="true" :close-on-click-modal="false" width="70%" :visible.sync="displayTeacherCourse" top="5vh">
          <teacherCourseReview :data="teacherCourseData" @close="closeTeacherCourse" v-on:dialogFormVisibleEvent="onTeacherDialogVisibleEvent"></teacherCourseReview>
        </el-dialog> 
    </div>
</template>

<style lang="scss" scoped>
.cs-course-validation {
  .red-icon {
    color: lightsalmon;
    margin-left: 3px;
  }
  width: 100%;
  padding: 0 40px;
  margin-bottom: 40px;
  .el-tabs {
    .el-tabs__header {
      margin: 0;
      .el-tabs__item {
        background-color: #cccccc;
        color: white;
        border: none;
        &.is-active {
          background-color: #006ab4;
        }
      }
    }
    .el-tabs__content {
      padding: 40px;
      background: white;
    }
  }
}
</style>

<script>
import studentCourseReview from "../studentCourseReview";
import teacherCourseReview from "../teacherCourseReview";
import { formatPhone } from "../../config/mUtils";

export default {
  data() {
    return {
      activeTab: "conflictType1",
      displayStudentCourse: false,
      currentStudentData: {},
      tableData: {},
      //planId: 0,
      termId: 0,
      plan:{},
      clickedConflictsInSPCourseAndStudentCourse: [],
      clickedConflictsInTwoSPCourses: [],
      displayTeacherCourse:false,
      teacherCourseData:{},
      clickedTeacherList: [],
    };
  },
  components: {
    studentCourseReview,
    teacherCourseReview
  },
  props: {
    data: {}
  },
  created() {
    this.loadData();
  },
  methods: {
    formatPhone(phone){
      if (!this.USERMANAGER.isAdmin){
        return formatPhone(phone);
      }
      return phone;
    },
    closeTeacherCourse() {
      this.displayTeacherCourse = false;
    },
    onTeacherDialogVisibleEvent(visible) {
      this.displayTeacherCourse = visible;
    },
    showTeacher(teacherId, teacherName){
      let previewData = {
        teacherId:teacherId, 
        teacherName:teacherName,
        plan: this.plan,
        termId: this.termId
      };

      this.teacherCourseData = previewData;
      this.displayTeacherCourse = true;
      if (this.clickedTeacherList.indexOf(teacherId) < 0){
        this.clickedTeacherList.push(teacherId);
      }
    },
    checkTeacherClicked(id) {
      if (this.clickedTeacherList.indexOf(id) < 0){
        return false;
      }
      return true;
    },
    getACourseName(item) {
      if (!item.ACourseClass) {
        return item.ACourseName;
      } else {
        return item.ACourseName + "-分班" + item.ACourseClass;
      }
    },
    getBCourseName(item) {
      if (!item.BCourseClass) {
        return item.BCourseName;
      } else {
        return item.BCourseName + "-分班" + item.BCourseClass;
      }
    },
    getCourseName(item) {
      if (!item.CourseClass) {
        return item.CourseName;
      } else {
        return item.CourseName + "-分班" + item.CourseClass;
      }
    },
    clickTab() {
      let self = this;
        setTimeout(function(){
          if (self.activeTab == "conflictType1"){
            self.$refs.tableConflictType1.doLayout();
          }else{
            self.$refs.tableConflictType2.doLayout();
          }
        }, 500)
    },
    cellStyle(cell) {
      if ((cell.rowIndex + 1) % 2 == 1) {
        return "el-table-cell-single";
      } else return "el-table-cell-double";
    },
    closeStudentCourse() {
      this.displayStudentCourse = false;
    },
    onDialogFormVisibleEvent(visible) {
      this.displayStudentCourse = visible;
    },
    showStudent(id, type, index) {
      this.currentStudentData = {
        studentId: id,
        planId: this.plan.Id,
        termId: this.termId
      };
      this.displayStudentCourse = true;

       let list = [];
      if (type == 1){    
        this.clickedConflictsInSPCourseAndStudentCourse.forEach(element => {
          list.push(element);
        });
        list[index] = true;
        this.clickedConflictsInSPCourseAndStudentCourse = list;
      }else if (type == 2){
        this.clickedConflictsInTwoSPCourses.forEach(element => {
          list.push(element);
        });
        list[index] = true;
        this.clickedConflictsInTwoSPCourses = list;
      }
    },
    checkConflictsInSPCourseAndStudentCourseIsClicked(index) {
      return this.clickedConflictsInSPCourseAndStudentCourse[index];
    },
    checkConflictsInTwoSPCoursesIsClicked(index) {
      return this.clickedConflictsInTwoSPCourses[index];
    },
    loadData() {
      this.plan = this.data.plan;
      this.tableData = this.data.tableData;
      this.termId = this.data.termId;

      this.clickedConflictsInSPCourseAndStudentCourse = [];
      if (this.data.ConflictsInSPCourseAndStudentCourse) {
        this.data.ConflictsInSPCourseAndStudentCourse.forEach(element => {
          this.clickedConflictsInSPCourseAndStudentCourse.push(false);
        });
      }

      this.clickedConflictsInTwoSPCourses = [];
      if (this.data.ConflictsInTwoSPCourses) {
        this.data.ConflictsInTwoSPCourses.forEach(element => {
          this.clickedConflictsInTwoSPCourses.push(false);
        });
      }
    }
  },
  watch: {
    data: function() {
      this.loadData();
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/speedupCourse/speedupCourseValidation.vue